import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { GeoQualityCell } from "./GeoQualityCell";
import { TableHeadSortLabel } from "./TableHeadSortLabel";

interface Props {
  aggregationUnit: string;
  activeSort: {
    property: "name" | "address" | "quality" | "aggregationUnit" | "currency";
    direction: "asc" | "desc";
  };
  handleSort: (
    property: "name" | "address" | "quality" | "aggregationUnit" | "currency"
  ) => void;
  t: (key: string) => string;
}

export function CandidatesTableHead({
  aggregationUnit,
  activeSort,
  handleSort,
  t
}: Props) {
  return (
    <TableHead>
      <TableRow>
        <TableHeadSortLabel
          property="name"
          activeSort={activeSort}
          handleSort={handleSort}
          width="15%"
        >
          {t("addressEncoding.table.name")}
        </TableHeadSortLabel>
        {aggregationUnit &&
          aggregationUnit !== "numberOfLocations" &&
          aggregationUnit !== "numberOfRisks" &&
          <TableHeadSortLabel
            property="currency"
            activeSort={activeSort}
            handleSort={handleSort}
            width="15%"
          >
            {t("locations.add.currency")}
          </TableHeadSortLabel>}
        {aggregationUnit &&
          aggregationUnit !== "numberOfLocations" &&
          <TableHeadSortLabel
            property="aggregationUnit"
            activeSort={activeSort}
            handleSort={handleSort}
            width="15%"
          >
            {t("locations.add." + aggregationUnit) || ""}
          </TableHeadSortLabel>}
        <TableHeadSortLabel
          property="address"
          activeSort={activeSort}
          handleSort={handleSort}
          width="40%"
        >
          {t("addressEncoding.table.address")}
        </TableHeadSortLabel>
        <GeoQualityCell
          activeSort={activeSort}
          handleSort={handleSort}
          t={t}
          hideSortIcon
        />
      </TableRow>
    </TableHead>
  );
}
